// TINY SLIDER
import {tns} from "tiny-slider/src/tiny-slider"

export const Slider = {

	stopDefAction: function (event) {
		event.preventDefault();
	},

	init: function (state) {
		let self = this;

		Array.prototype.slice.call(document.querySelectorAll('.js-slider')).forEach(x => {
			let items = x.dataset.items === undefined ? 1 : Number(x.dataset.items);
			let autoHeight = x.dataset.autoheight === "true" ? true : false;
			let autoPlay = x.dataset.autoplay === "true" ? true : false;
			let autoplayTimeout = x.dataset.autoplaytimeout;

			var slider = tns({
				items: items,
				mouseDrag: false,
				lazyload: true,
				container: x,
				autoplay: autoPlay,
				autoplayButton: false,
				swipeAngle: false,
				autoHeight: autoHeight,
				autoplayTimeout: autoplayTimeout,
				autoplayButtonOutput: false,
				speed: 400,
				controls: true,
				controlsText: ['<', '>'],
				slideBy: "page",
				rewind: true,
				onInit: function (slider) {
					let navIt = Array.prototype.slice.call(slider.navContainer.querySelectorAll('button'));
					slider.container.classList.add('is-init');
					slider.navContainer.classList.add('c-slider__nav');

					navIt.forEach(x => {
						x.classList.add('c-slider__nav-item')
					})
				}
			});
		})

		document.querySelectorAll('.tns-controls button').forEach(function (element) {
			element.addEventListener('click', self.stopDefAction, false);
		});
	}
};

window.Slider = Slider;
Slider.init();
